import { type ActionFunction } from '@remix-run/node'

export const MIN_CHAR_LIMIT = 5

interface MapboxResponse {
	features: {
		center: [number, number]
		place_name: string
	}[]
}

export const action: ActionFunction = async ({ request }) => {
	if (request.method.toUpperCase() !== 'POST') {
		return new Response('Invalid request method', { status: 405 })
	}

	const params = new URLSearchParams(await request.text())
	const address = params.get('address')

	if (!address || address.length <= MIN_CHAR_LIMIT) {
		return new Response(JSON.stringify({ addresses: [] }), {
			status: 200,
			headers: { 'Content-Type': 'application/json' },
		})
	}

	const encodedQuery = encodeURIComponent(address)
	const res = await fetch(
		`${process.env.MAPBOX_GEOCODING_BASE_URL}${encodedQuery}.json?country=US,CA&access_token=${process.env.MAPBOX_TOKEN}`,
	)

	if (!res.ok) {
		return new Response('Failed to fetch addresses', { status: res.status })
	}

	const data = (await res.json()) as MapboxResponse
	const addresses = data.features.map(r => {
		let [lon, lat] = r.center
		return {
			value: { address: r.place_name, lat, lon },
			label: r.place_name,
		}
	})

	return new Response(JSON.stringify({ addresses }), {
		status: 200,
		headers: { 'Content-Type': 'application/json' },
	})
}
